import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { ErrorDialogActions } from './error-dialog.actions';
import { ErrorDialogEntry } from './error-dialog.model';
import { ErrorDialogSelectors } from './error-dialog.reducer';

/**
 * Global, single-instance dialog that displays error messages collected from
 * `ToastActions.showToastError` / `showToastApiError`. The dialog stays open
 * until the user dismisses the errors one by one or closes the dialog (which
 * clears all of them). Mounted once in the root layout.
 */
@Component({
  selector: 'ral-error-dialog',
  templateUrl: './error-dialog.component.html',
  styles: [
    `
      .error-dialog__item {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 0.5rem;
      }
      .error-dialog__item + .error-dialog__item {
        margin-top: 0.5rem;
      }
      .error-dialog__text {
        margin: 0;
        word-break: break-word;
      }
      .error-dialog__title {
        display: block;
      }
      .error-dialog__dismiss {
        flex: 0 0 auto;
        background: transparent;
        border: 0;
        padding: 0.25rem;
        cursor: pointer;
        color: inherit;
        line-height: 1;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RalErrorDialogComponent {
  readonly errors$ = this.store.select(ErrorDialogSelectors.selectAllErrors);
  readonly hasErrors$ = this.store.select(ErrorDialogSelectors.selectHasErrors);

  constructor(private readonly store: Store) {}

  trackById(_index: number, error: ErrorDialogEntry): number {
    return error.id;
  }

  dismiss(id: number): void {
    this.store.dispatch(ErrorDialogActions.dismissError({ id }));
  }

  dismissAll(): void {
    this.store.dispatch(ErrorDialogActions.dismissAllErrors());
  }
}
